'use client'

import { TelegramLogin } from '~/components/auth/telegram-login'
import { Skeleton } from '~/components/ui/skeleton'
import { useSession } from '~/lib/auth.client'

export function TelegramLoginButton() {
  const { data: session, isPending } = useSession()

  if (session) {
    return null
  }

  if (isPending) {
    return <Skeleton className="h-10 w-24 md:w-60" />
  }

  return <TelegramLogin align="left" />
}
